// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification--info[data-v-68b65652] {\n  background-color: #212121;\n  color: var(--magic-light, #fff);\n}\n\n.cookie-popup-text[data-v-68b65652] {\n  background-color: #212121;\n  color: var(--magic-light, #fff);\n  padding: var(--magic-space, 16px);\n  margin: var(--magic-space--large, 32px) var(--magic-space, 16px);\n}", ""]);
// Exports
module.exports = exports;
